/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
//  BarC,
  BoxC,
  BtnC,
  CbxC,
  IptC,
  LblC,
  MsgC,
  SrlC,
  TextC,
  GridC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';

import * as icvI19___Ci from './icvI19___Ci';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnOrnz',
          boxStlz: a(`mb/2 sc/rd5`),
          lineCs: [{
            cellCs: [
              {
                oClds: [
                ]
              },
              {
                oClds: [
                ]
              },
              {
                oClds: [
/*
                  cr.c(LblC.N, {
                    key: -10,
                    abtType: 'ftnCmnz',
                    boxStlz: a('dw/23'),
                    lblCz: {
                      boxStlz: a('dw/8'),
                      textz: {
                        pfx: '変更履歴',
                      }
                    },
                    cttCz: {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          abtType: 'ftnCmnz',
                          cz: {
                            bEdit: true,
                            iptType: 'pcr',
                            ls: [],
                          },
                        })
                      ]
                    },
                  })
*/
                ]
              }
            ]
          }]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
//          boxStlz: a(`sc/rd1`),
          oClds: [

/*
            cr.c(MsgC.N, {
              key: -10,
              abtType: 'cttCmnz',
              boxStlz: a('mb/2'),
              cz: {
                ls: [
                  {
                    mkrCz: {
                      textz: {
                        pfx: _lblz.msgz.cttz.mkr
                      }
                    },
                    msgCz: {
                      textz: {
                        pfx: _lblz.msgz.cttz.msg
                      }
                    }
                  },
                ]
              },
            }),
*/

            cr.c(SrlC.V, {
              key: -20,
              srlStlz: {
                otrz: a('dw/f dwx/120 f/1'),
              },
              oClds: [
                cr.c(icvI19___Ci.D, {
                  key: -10,
                  sPz: pz.sPz,
                  cz: {
                    ccd: 'rd',
                  },
                }),
              ],
            }),

            cr.c(icvI19___Ci.B, {
              key: -30,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'rd7',
              },
            }),

          ]
        })

      ]
    })
  );
};
